const $ = jQuery.noConflict();
import PerfectScrollbar from 'perfect-scrollbar';

'use strict';
const PSB = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	selectorStyleguideNav: '.js-styleguide-nav-list-holder',
	classHide: 'hideFade',

	/** @description Initialize */
	init: ()=> {
		PSB.addPScrollToElement();
		PSB.perfectScrollBarStyleguide();
	},

	/**
	 * @description Stylequide scrollbar
	 */
	perfectScrollBarStyleguide: () => {
		$(PSB.selectorStyleguideNav).each((i, el)=> {
			const selector = $(el)[0];

			const ps = new PerfectScrollbar(selector, {
				wheelSpeed: 1,
				suppressScrollX: true,
				minScrollbarLength: 100,
			});

			selector.addEventListener('ps-scroll-y', (e) => {
				const _self = $(e.currentTarget);
				const reach = ps.reach.y;

				reach === 'end' ? _self.parent().addClass(PSB.classHide) : _self.parent().removeClass(PSB.classHide);
			});
		});
	},

	// addPScrollToElement: () => {
	// 	$('.select2-selection__rendered').addClass('js-styleguide-nav-list-holder');
	// 	// $('.select2-selection__rendered').addClass('hideFade');
	// }

	addPScrollToElement: () => {
		const isTouch = ('ontouchstart' in document.documentElement);

		if ( !isTouch ) {
			$('.js-select-multiple').on('select2:opening', function () {
				setTimeout(() => {
					$('.select2-results__options').addClass('js-styleguide-nav-list-holder');
					PSB.perfectScrollBarStyleguide();
				}, 0);
			});
		}
	},
};

export default PSB;
